import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListMagnify = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75H17.25C17.6642 3.75 18 4.08579 18 4.5C18 4.91421 17.6642 5.25 17.25 5.25H3C2.58579 5.25 2.25 4.91421 2.25 4.5ZM2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H12.75C13.1642 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.1642 9.75 12.75 9.75H3C2.58579 9.75 2.25 9.41421 2.25 9ZM15.571 12.3047C13.7739 12.3047 12.3171 13.7615 12.3171 15.5585C12.3171 17.3556 13.7739 18.8124 15.571 18.8124C16.4697 18.8124 17.2822 18.449 17.8718 17.8594C18.4615 17.2697 18.8249 16.4573 18.8249 15.5585C18.8249 13.7615 17.368 12.3047 15.571 12.3047ZM10.8171 15.5585C10.8171 12.9331 12.9455 10.8047 15.571 10.8047C18.1965 10.8047 20.3249 12.9331 20.3249 15.5585C20.3249 16.6003 19.9891 17.5645 19.4209 18.3478L21.7067 20.6336C21.9996 20.9265 21.9996 21.4014 21.7067 21.6943C21.4138 21.9872 20.939 21.9872 20.6461 21.6943L18.3602 19.4084C17.577 19.9767 16.6128 20.3124 15.571 20.3124C12.9455 20.3124 10.8171 18.184 10.8171 15.5585ZM2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75H8.25C8.66421 12.75 9 13.0858 9 13.5C9 13.9142 8.66421 14.25 8.25 14.25H3C2.58579 14.25 2.25 13.9142 2.25 13.5Z",
		fill: "currentcolor"
	})]
});
export default SvgListMagnify;
